import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { jsonDeepParse } from 'src/app/functions/shared-functions';
import { OfferDetailsService } from 'src/app/modules/my-journey/services/offer-details/offer-details.service';
import { WorkbenchService } from 'src/app/services/workbench.service';

@Component({
  selector: 'app-pre-offer',
  templateUrl: './pre-offer.component.html',
  styleUrls: ['./pre-offer.component.scss'],
  providers: [OfferDetailsService, WorkbenchService,
    // {
    //   provide: STEPPER_GLOBAL_OPTIONS,
    //   useValue: { displayDefaultIndicatorType: false },
    // },
  ]
})
export class PreOfferComponent implements OnInit {
  verificationObj = {};
  // field_config_access
  // = {
  //   "offer_firstName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_firstName",
  //     "label": "First Name",
  //     "placeholder": "Enter first name"
  //   },
  //   "offer_lastName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_lastName",
  //     "label": "Last Name",
  //     "placeholder": "Enter last name"
  //   },
  //   "offer_personalDetails": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_personalDetails",
  //     "label": "Personal Details",
  //     "placeholder": null
  //   },
  //   "offer_educationDetails": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_educationDetails",
  //     "label": "Education Details",
  //     "placeholder": null
  //   },
  //   "offer_familyDetails": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_familyDetails",
  //     "label": "Family Details",
  //     "placeholder": null
  //   },
  //   "offer_workExperience": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_workExperience",
  //     "label": "Work Experience",
  //     "placeholder": null
  //   },
  //   "offer_referenceAndAdditonalDetails": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_referenceAndAdditonalDetails",
  //     "label": "Reference and Additional Details",
  //     "placeholder": null
  //   },
  //   "declaration": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "",
  //     "label": "<p>I hereby declare that I am not under any service obligation / agreement other than the notice period stated in Para 7 above to serve any other employer.  If offered, I would join duty only after getting properly relieved by my current employer.  I also declare that I have no criminal / legal proceedings pending against me. </p> <p> I authorize Korcomptenz or its representative to undertake to do a background verification and enquiry in connection with my employment with Korcomptenz Consultancy Private Ltd. </p><p>I have no objection in sharing my personal information and documents with Korcomptenz for the purpose of background checks and verifications. </p><p>I certify   that the   information furnished above is   true to   the best of my   knowledge and any Misrepresentation made by me in this form will render me liable and not eligible for the offered position.</p>",
  //     "placeholder": null
  //   },
  //   "offer_middleName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_middleName",
  //     "label": "Middle Name",
  //     "placeholder": "Enter middle name"
  //   },
  //   "offer_profilePhoto": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_profilePhoto",
  //     "label": "Profile Photo",
  //     "placeholder": "Attach Photograph"
  //   },
  //   "offer_gender": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_gender",
  //     "label": "Gender",
  //     "placeholder": "Select Gender"
  //   },
  //   "dob": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "dob",
  //     "label": "Date of birth",
  //     "placeholder": "Select Date of birth"
  //   },
  //   "nationalityId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "nationalityId",
  //     "label": "Nationality",
  //     "placeholder": "Select Nationality"
  //   },
  //   "maritalStatusId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "maritalStatusId",
  //     "label": "Marital Status",
  //     "placeholder": "Select Marital Status"
  //   },
  //   "localAddress": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "localAddress",
  //     "label": "Local Address",
  //     "placeholder": "Enter Local Address"
  //   },
  //   "title": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "title",
  //     "label": "Academic Awards / Scholarships / Prizes",
  //     "placeholder": "Enter Academic Awards / Scholarships / Prizes"
  //   },
  //   "cityId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "cityId",
  //     "label": "City Name",
  //     "placeholder": "Select City Name"
  //   },
  //   "status": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "status",
  //     "label": "Status",
  //     "placeholder": "Select Status"
  //   },
  //   "stateId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "stateId",
  //     "label": "State Name",
  //     "placeholder": "Select State Name"
  //   },
  //   "countryId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "countryId",
  //     "label": "Country name",
  //     "placeholder": "Select Country Name"
  //   },
  //   "postalCode": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "postalCode",
  //     "label": "Postal Code",
  //     "placeholder": "Enter Postal Code"
  //   },
  //   "attachments": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "attachments",
  //     "label": "Attach Certificates",
  //     "placeholder": "Attach Certificates"
  //   },
  //   "addressLine1": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "addressLine1",
  //     "label": "Address Line",
  //     "placeholder": "Enter Address Line"
  //   },
  //   "permanentAddress": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "permanentAddress",
  //     "label": "Permanent Address",
  //     "placeholder": "Enter Permanent Address"
  //   },
  //   "mobileIsd": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "mobileIsd",
  //     "label": "Mobile Number",
  //     "placeholder": "Select Country Code"
  //   },
  //   "mobileNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "mobileNumber",
  //     "label": "Mobile Number",
  //     "placeholder": "Enter Mobile Number"
  //   },
  //   "altMobileIsd": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "altMobileIsd",
  //     "label": "Alternative Mobile Number",
  //     "placeholder": null
  //   },
  //   "altMobileNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "altMobileNumber",
  //     "label": "Alternative Mobile Number",
  //     "placeholder": "Enter Alternative Mobile Number"
  //   },
  //   "emailId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "emailId",
  //     "label": "Email ID",
  //     "placeholder": "Enter Email ID"
  //   },
  //   "altEmailId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "altEmailId",
  //     "label": "Alternative Email ID",
  //     "placeholder": "Enter Alternative Email ID"
  //   },
  //   "hasValidPassport": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "hasValidPassport",
  //     "label": "Valid Passport",
  //     "placeholder": null
  //   },
  //   "ppExpiryDate": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "ppExpiryDate",
  //     "label": "Passport Expiry Date",
  //     "placeholder": "Select Passport Expiry Date"
  //   },
  //   "ppNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "ppNumber",
  //     "label": "Passport Number",
  //     "placeholder": "Enter Passport Number"
  //   },
  //   "isECR": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "isECR",
  //     "label": "ECNR / ECR",
  //     "placeholder": null
  //   },
  //   "hasValidVisa": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "hasValidVisa",
  //     "label": "Do you have valid visa?",
  //     "placeholder": null
  //   },
  //   "visaPermits": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "visaPermits",
  //     "label": null,
  //     "placeholder": null
  //   },
  //   "visaPermitTypeId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "visaPermitTypeId",
  //     "label": "Visa Permits",
  //     "placeholder": "Select Visa Permits"
  //   },
  //   "visaCountryId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "visaCountryId",
  //     "label": "Visa Country",
  //     "placeholder": "Select Visa Country"
  //   },
  //   "experience": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "experience",
  //     "label": "Experience",
  //     "placeholder": "Enter Experience"
  //   },
  //   "languages": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "languages",
  //     "label": "Languages",
  //     "placeholder": "Select Languages"
  //   },
  //   "foreignLanguages": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "foreignLanguages",
  //     "label": "Foreign Languages",
  //     "placeholder": "Select Foreign Languages"
  //   },
  //   "sourceId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "sourceId",
  //     "label": "Source",
  //     "placeholder": "Select Source"
  //   },
  //   "sourceRefText": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "sourceRefText",
  //     "label": "Source Ref",
  //     "placeholder": "Enter Source Ref"
  //   },
  //   "educations": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "educations",
  //     "label": "Educational Qualification",
  //     "placeholder": null
  //   },
  //   "educationCode": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "educationCode",
  //     "label": "Education",
  //     "placeholder": "Select Education"
  //   },
  //   "specializationCode": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "specializationCode",
  //     "label": "Specialization",
  //     "placeholder": "Select Specialization"
  //   },
  //   "educationType": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "educationType",
  //     "label": "Education Type",
  //     "placeholder": "Select Education Type"
  //   },
  //   "passingMN": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "passingMN",
  //     "label": "Month & Year of Passing",
  //     "placeholder": "Select Month & Year of Passing"
  //   },
  //   "universityCode": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "universityCode",
  //     "label": "University",
  //     "placeholder": "Select or Enter University"
  //   },
  //   "collegeCode": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "collegeCode",
  //     "label": "College Name",
  //     "placeholder": "Select or Enter College Name"
  //   },
  //   "mediumOfInst": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "mediumOfInst",
  //     "label": "Medium of Instruction",
  //     "placeholder": "Enter Medium of Instruction"
  //   },
  //   "percentage": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "percentage",
  //     "label": "Percentage",
  //     "placeholder": "Percentage"
  //   },
  //   "percentageType": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "percentageType",
  //     "label": "Type",
  //     "placeholder": ""
  //   },
  //   "achievements": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "achievements",
  //     "label": "Academic Awards / Scholarships / Prizes",
  //     "placeholder": null
  //   },
  //   "cdnPath": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "cdnPath",
  //     "label": null,
  //     "placeholder": null
  //   },
  //   "fileName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "fileName",
  //     "label": null,
  //     "placeholder": null
  //   },
  //   "profQualifications": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "profQualifications",
  //     "label": "Professional Qualifications",
  //     "placeholder": "Enter Qualifications"
  //   },
  //   "course": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "course",
  //     "label": "Professional Qualification",
  //     "placeholder": "Enter Professional Qualification"
  //   },
  //   "yearFrom": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "yearFrom",
  //     "label": "Year from",
  //     "placeholder": "Select Year from"
  //   },
  //   "yearTo": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "yearTo",
  //     "label": "Year to",
  //     "placeholder": "Select Year to"
  //   },
  //   "courseTypeId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "courseTypeId",
  //     "label": "Course Type",
  //     "placeholder": "Select Course Type"
  //   },
  //   "duration": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "duration",
  //     "label": "Duration",
  //     "placeholder": "Select Duration"
  //   },
  //   "instituteName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "instituteName",
  //     "label": "Institute Name",
  //     "placeholder": "Enter Institute Name"
  //   },
  //   "address": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "address",
  //     "label": "Address",
  //     "placeholder": "Enter Address"
  //   },
  //   "grade": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "grade",
  //     "label": "Grade",
  //     "placeholder": "Select Grade"
  //   },
  //   "familyDetails": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "familyDetails",
  //     "label": "Family Details",
  //     "placeholder": "Enter Family Details"
  //   },
  //   "relationTypeId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "relationTypeId",
  //     "label": "Relation Type",
  //     "placeholder": "Select Relation Type"
  //   },
  //   "name": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "name",
  //     "label": "Name",
  //     "placeholder": "Enter Name"
  //   },
  //   "age": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "age",
  //     "label": "Age",
  //     "placeholder": "Enter Age"
  //   },
  //   "qualificationId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "qualificationId",
  //     "label": "Qualification",
  //     "placeholder": "Select Qualification"
  //   },
  //   "occupation": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "occupation",
  //     "label": "Occupation",
  //     "placeholder": "Enter Occupation"
  //   },
  //   "designationId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "designationId",
  //     "label": "Designation",
  //     "placeholder": "Select Designation"
  //   },
  //   "companyName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "companyName",
  //     "label": "Company Name",
  //     "placeholder": "Enter Company Name"
  //   },
  //   "anyRelativeWorkingInCompany": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "anyRelativeWorkingInCompany",
  //     "label": "Do you have any relative(s) working with Korcomptenz or its Group companies?",
  //     "placeholder": null
  //   },
  //   "workingRelativeName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "workingRelativeName",
  //     "label": "If Yes, please specify Name",
  //     "placeholder": "Enter Name"
  //   },
  //   "workingRelativeDepartment": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "workingRelativeDepartment",
  //     "label": "If Yes, please specify Department",
  //     "placeholder": "Enter Department "
  //   },
  //   "workHistory": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "workHistory",
  //     "label": "Work History",
  //     "placeholder": "Enter Work History"
  //   },
  //   "phoneNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "phoneNumber",
  //     "label": "Phone Number",
  //     "placeholder": "Enter Phone Number"
  //   },
  //   "fromDate": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "fromDate",
  //     "label": "Employment From date",
  //     "placeholder": "Select From date"
  //   },
  //   "toDate": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "toDate",
  //     "label": "Employment To date",
  //     "placeholder": "Select To date"
  //   },
  //   "durationYear": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "durationYear",
  //     "label": "Year",
  //     "placeholder": null
  //   },
  //   "durationMonth": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "durationMonth",
  //     "label": "Month",
  //     "placeholder": null
  //   },
  //   "jobContent": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "jobContent",
  //     "label": "Job Content",
  //     "placeholder": "Enter Job Content (in brief)"
  //   },
  //   "annualCTC": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "annualCTC",
  //     "label": "Annual CTC",
  //     "placeholder": "Enter Annual CTC"
  //   },
  //   "reasonOfLeaving": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "reasonOfLeaving",
  //     "label": "Reason Of Leaving",
  //     "placeholder": "Enter Reason Of Leaving"
  //   },
  //   "fixedCurrentSalary": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "fixedCurrentSalary ",
  //     "label": "Fixed Current Salary ",
  //     "placeholder": "Enter Fixed Current Salary "
  //   },
  //   "variableCurrentSalary": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "variableCurrentSalary",
  //     "label": "Variable Current Salary",
  //     "placeholder": "Enter Variable Current Salary"
  //   },
  //   "presentCTCCurrencyId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "presentCTCCurrencyId",
  //     "label": "Present CTC Currency",
  //     "placeholder": "Select Present CTC Currency"
  //   },
  //   "presentCTC": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "presentCTC",
  //     "label": "Present CTC",
  //     "placeholder": "Enter Present CTC"
  //   },
  //   "presentCTCDurationId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "presentCTCDurationId",
  //     "label": "Present CTC Duration",
  //     "placeholder": "Select Present CTC Duration"
  //   },
  //   "totalExperience": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "totalExperience",
  //     "label": "Total Experience",
  //     "placeholder": "Enter total experience in years"
  //   },
  //   "relevantExperience": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "relevantExperience",
  //     "label": "Relevant Experience",
  //     "placeholder": "Enter relevant experience in years"
  //   },
  //   "expectedCTCCurrencyId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "expectedCTCCurrencyId",
  //     "label": "Expected CTC Currency",
  //     "placeholder": "Select Expected CTC Currency"
  //   },
  //   "expectedCTCAmount": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "expectedCTCAmount",
  //     "label": "Expected CTC Amount",
  //     "placeholder": "Enter Expected CTC Amount"
  //   },
  //   "expectedCTCDurationId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "expectedCTCDurationId",
  //     "label": "Expected CTC Duration",
  //     "placeholder": "Select Expected CTC Duration"
  //   },
  //   "noticePeriod": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "noticePeriod",
  //     "label": "Notice Period",
  //     "placeholder": "Enter Notice Period"
  //   },
  //   "primaryReferences": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "primaryReferences",
  //     "label": "Primary Reference",
  //     "placeholder": "Enter Primary Reference"
  //   },
  //   "firstName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "firstName",
  //     "label": "First Name",
  //     "placeholder": "Enter First Name"
  //   },
  //   "lastName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "lastName",
  //     "label": "Last Name",
  //     "placeholder": "Enter Last Name"
  //   },
  //   "notes": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "notes",
  //     "label": "Notes",
  //     "placeholder": "Enter Notes"
  //   },
  //   "knownSince": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "knownSince",
  //     "label": "Period for which known",
  //     "placeholder": "Mention Period for which known "
  //   },
  //   "capacityOfKnowing": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "capacityOfKnowing",
  //     "label": "Capacity in which he /she knows you",
  //     "placeholder": "Mention Capacity in which he /she knows you"
  //   },
  //   "secondaryReferences": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "secondaryReferences",
  //     "label": "Secondary Reference",
  //     "placeholder": "Enter Secondary Reference"
  //   },
  //   "firstName ": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "firstName ",
  //     "label": "First Name ",
  //     "placeholder": "Enter First Name "
  //   },
  //   "describeWhyWorkWithUs": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "describeWhyWorkWithUs",
  //     "label": "Complete the following in not less than 20 words",
  //     "placeholder": "I would like to be a part of the Korcomptenz family because:"
  //   },
  //   "describeWhyWorkWithUsLabel": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "describeWhyWorkWithUsLabel",
  //     "label": "I would like to be a part of the Korcomptenz family because",
  //     "placeholder": "I would like to be a part of the Korcomptenz family because:"
  //   },
  //   "extraCurrActivities": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "extraCurrActivities",
  //     "label": "Extra Curricular Activities",
  //     "placeholder": "Mention Extra Curricular Activities"
  //   },
  //   "favFood": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "favFood",
  //     "label": "Favourite Food",
  //     "placeholder": "Favourite Food"
  //   },
  //   "favHobbies": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "favHobbies",
  //     "label": "Favourite Hobbies",
  //     "placeholder": "Favourite Hobbies"
  //   },
  //   "favQuoteWithAuthor": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "favQuoteWithAuthor",
  //     "label": "Favourite QuoteWithAuthor",
  //     "placeholder": "Favourite QuoteWithAuthor"
  //   },
  //   "personalSW": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "personalSW",
  //     "label": "Personal Strengths",
  //     "placeholder": "Mention Personal Strengths"
  //   },
  //   "rating": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "rating",
  //     "label": "Ratings",
  //     "placeholder": null
  //   },
  //   "assessment": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "assessment",
  //     "label": "Other Details",
  //     "placeholder": null
  //   },
  //   "qCode": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "qCode",
  //     "label": null,
  //     "placeholder": null
  //   },
  //   "optionCode": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "optionCode",
  //     "label": null,
  //     "placeholder": null
  //   },
  //   "inputAnswer": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "inputAnswer",
  //     "label": null,
  //     "placeholder": null
  //   },
  //   "declarationSignature": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "declarationSignature",
  //     "label": "Signature",
  //     "placeholder": "Signature"
  //   },
  //   "declarationDt": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "declarationDt",
  //     "label": "Date",
  //     "placeholder": "Enter Date"
  //   },
  //   "declarationPlace": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "declarationPlace",
  //     "label": "Place",
  //     "placeholder": "Enter Place"
  //   },
  //   "WH_designationId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "WH_designationId",
  //     "label": "Designation",
  //     "placeholder": "<-- Select -->"
  //   },
  //   "prFirstName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prFirstName ",
  //     "label": "First Name ",
  //     "placeholder": "Enter First Name "
  //   },
  //   "prLastName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prLastName",
  //     "label": "Last Name",
  //     "placeholder": "Enter Last Name"
  //   },
  //   "prAddress": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prAddress",
  //     "label": "Address",
  //     "placeholder": "Enter Address"
  //   },
  //   "prMobileIsd": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prMobileIsd",
  //     "label": "Country Code",
  //     "placeholder": "Select Country Code"
  //   },
  //   "prMobileNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prMobileNumber",
  //     "label": "Mobile Number",
  //     "placeholder": "Enter Mobile Number"
  //   },
  //   "prEmailId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prEmailId",
  //     "label": "Email ID",
  //     "placeholder": "Enter Email ID"
  //   },
  //   "prCompanyName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prCompanyName",
  //     "label": "Company Name",
  //     "placeholder": "Enter Company Name"
  //   },
  //   "prDesignationId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prDesignationId",
  //     "label": "Designation",
  //     "placeholder": "Select Designation"
  //   },
  //   "prNotes": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "prNotes",
  //     "label": "Notes",
  //     "placeholder": "Enter Notes"
  //   },
  //   "srFirstName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srFirstName ",
  //     "label": "First Name ",
  //     "placeholder": "Enter First Name "
  //   },
  //   "srLastName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srLastName",
  //     "label": "Last Name",
  //     "placeholder": "Enter Last Name"
  //   },
  //   "srAddress": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srAddress",
  //     "label": "Address",
  //     "placeholder": "Enter Address"
  //   },
  //   "srMobileIsd": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srMobileIsd",
  //     "label": "Country Code",
  //     "placeholder": "Select Country Code"
  //   },
  //   "srMobileNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srMobileNumber",
  //     "label": "Mobile Number",
  //     "placeholder": "Enter Mobile Number"
  //   },
  //   "srEmailId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srEmailId",
  //     "label": "Email ID",
  //     "placeholder": "Enter Email ID"
  //   },
  //   "srCompanyName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srCompanyName",
  //     "label": "Company Name",
  //     "placeholder": "Enter Company Name"
  //   },
  //   "srDesignationId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srDesignationId",
  //     "label": "Designation",
  //     "placeholder": "Select Designation"
  //   },
  //   "srNotes": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "srNotes",
  //     "label": "Notes",
  //     "placeholder": "Enter Notes"
  //   },
  //   "extended": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "extended",
  //     "label": "Documents",
  //     "placeholder": "Enter Notes"
  //   },
  //   "otherDetails": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "otherDetails",
  //     "label": "Other Details",
  //     "placeholder": "Enter Notes"
  //   },
  //   "pswTitle": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "pswTitle",
  //     "label": "Strength",
  //     "placeholder": "Enter Strength"
  //   },
  //   "declarationSection": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "pswTitle",
  //     "label": "Declaration",
  //     "placeholder": "Enter Declaration"
  //   },
  //   "employeeNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "employeeNumber",
  //     "label": "Employee Number",
  //     "placeholder": "Enter Employee Number"
  //   },
  //   "dateOfJoining": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "dateOfJoining",
  //     "label": "Date of Joining",
  //     "placeholder": "Select Date of Joining"
  //   },
  //   "dateOfRelieving": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "dateOfRelieving",
  //     "label": "Date of Relieving",
  //     "placeholder": "Select Date of Relieving"
  //   },
  //   "lastDrawnCTC": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "lastDrawnCTC",
  //     "label": "Last Drawn CTC",
  //     "placeholder": "Enter Last Drawn CTC"
  //   },
  //   "HRName": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "HRName",
  //     "label": "HR Name",
  //     "placeholder": "Enter HR Name"
  //   },
  //   "HREmailId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "HREmailId",
  //     "label": "HR Email Id",
  //     "placeholder": "Enter HR Email Id"
  //   },
  //   "HRContactIsd": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "HRContactIsd",
  //     "label": "ISD",
  //     "placeholder": "Select ISD"
  //   },
  //   "HRContactNumber": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "HRContactNumber",
  //     "label": "HR Contact Number",
  //     "placeholder": "Enter HR Contact Number"
  //   },
  //   "lastDrawnCTCCurrencyId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "Currency",
  //     "label": "Currency",
  //     "placeholder": "Currency"
  //   },
  //   "annualCTCCurrencyId": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "Currency",
  //     "label": "Currency",
  //     "placeholder": "Currency"
  //   },
  //   "offer_documents": {
  //     "validators": {
  //       "mandatory": "1"
  //     },
  //     "fieldID": "offer_documents",
  //     "label": "Documents",
  //     "placeholder": "Documents"
  //   }
  // }

  form_details;
  @Input() disable_action;
  @Output() formSaved = new EventEmitter();
  @Input() first_login_details;
  lockOfferDetailsFlag = false;
  constructor(private pre_offer_srv: OfferDetailsService) {

  }
  ngOnInit(): void {
    this.getPreOfferDetails();
  }

  getPreOfferDetails() {
    this.pre_offer_srv.getPreOfferDetails({ type: 3 }).subscribe(res => {
      if (res && res['data'] && res['status']) {
        if (res['data'].detail) {
          this.lockOfferDetailsFlag = res['data'].detail.lockOfferPersonalDetailsFlag ? true : false;
          this.form_details = jsonDeepParse(res['data'].detail);
          this.verificationObj = res['data'].detail.verificationStatus || {};
        }

        // this.field_config_access = res['']
        // this.personal_details_form.patchValue(this.details);

      }
    })
  }
}

